import {
  fetchAll,
  fetchFiltered,
  show,
  add,
  edit
} from '@/api/activestatus'
import { t } from '@/lib/i18n'

const state = {
  all: [],
  isLoading: false,
  activestatusById: null
}

const actions = {
  cleanState ({ commit }) {
    commit('cleanState')
  },

  async fetchAll ({ dispatch, commit }) {
    try {
      const activeStatus = await fetchAll()
      commit('setAll', activeStatus)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchById ({ dispatch, commit }, id) {
    try {
      const activeStatus = await show(id)
      commit('setActiveStatusById', activeStatus)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async fetchFiltered ({ dispatch, commit }, queriesParams) {
    try {
      const activeStatus = await fetchFiltered(queriesParams)
      commit('setAll', activeStatus)
    } catch (e) {
      dispatch('notify/error', e, { root: true })
    }
  },

  async edit ({ dispatch, commit }, { id, data }) {
    commit('setLoading', true)
    try {
      await edit(id, data)
      return true
    } catch (e) {
      dispatch('notify/error', { message: t(e.message) || e }, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  },

  async create ({ dispatch, commit }, data) {
    commit('setLoading', true)
    try {
      await add(data)
      return true
    } catch (e) {
      dispatch('notify/error', { message: t(e.message) || e }, { root: true })
    } finally {
      commit('setLoading', false)
    }
    return false
  }
}

const mutations = {
  cleanState (state) {
    state.all = []
    state.activestatusById = null
    state.isLoading = false
  },

  setAll (state, activeStatus) {
    state.all = activeStatus
  },

  setActiveStatusById (state, activeStatus) {
    state.activestatusById = activeStatus
  },

  setLoading (state, isLoading) {
    state.isLoading = isLoading
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}